import React, { FC } from 'react';
import { TextField } from '@src/components/TextField';
import { Button } from '@src/components/Button';
import { VerifyAuthCodeProps } from './props';
import './styles.scss';

export const VerifyAuthCode: FC<VerifyAuthCodeProps> = ({ verifyCode, isLoading, setVerifyCode, onVerify }) => {
  return (
    <div className="verify-login fade-in">
      <div className="verify-login__header-content">
        <h3>Log in using email</h3>
        <p>Enter the code from your authenticator app to continue.</p>
      </div>
      <div>
        <TextField
          defaultValue={verifyCode}
          fullWidth={true}
          label="Verification Code"
          onChange={value => setVerifyCode(value)}
          placeholder="Verification Code"
          wrapperClassName="verify-login__input"
        />
      </div>
      <div className="verify-login__actions">
        <p className="verify-login__lost-mfa">
          Lost your MFA method?{' '}
          <a href="mailto:team@meetfrank.com" rel="noreferrer noopener" target="_blank">
            Contact us
          </a>
        </p>

        <Button className="verify-login__continue-button" isDisabled={!verifyCode || isLoading} onClick={onVerify}>
          Verify
        </Button>
      </div>
    </div>
  );
};
